import { Component, OnInit, AfterViewInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AutenticacaoInfo, AutenticacaoService, AutenticacaoStatus } from 'src/app/autenticacao/autenticacao.service';
import jwt_decode from 'jwt-decode';
import { AutenticacaoDto, TipoAutenticacao } from 'src/app/autenticacao/modelos/autenticacao-dto';
import { ToastService } from 'src/app/libs/toast/toast.service';
import { PacientePesquisaComponent } from 'src/app/pesquisa/paciente-pesquisa/paciente-pesquisa.component';
import { PacienteDto } from 'src/app/dtos/pacientes/paciente-dto';
import { UsuarioService } from 'src/app/autenticacao/usuario.service';
import { ProfissionalProfissaoTipo } from 'src/app/autenticacao/modelos/usuario';
import * as Sentry from '@sentry/angular';

interface PesquisaPacienteForm {
  nomeCpf: FormControl<string>
}

@Component({
  selector: 'app-barra-lateral',
  templateUrl: './barra-lateral.component.html',
  styleUrls: ['./barra-lateral.component.less']
})
export class BarraLateralComponent implements OnInit, AfterViewInit {

  @ViewChild('pacientePesquisa')
  pacientePesquisaModal!: PacientePesquisaComponent;

  AutenticacaoStatus = AutenticacaoStatus;

  modelo: FormGroup<PesquisaPacienteForm> = this.fb.nonNullable.group({
    nomeCpf: ['']
  });

  @Output()
  onViewInit: EventEmitter<any> = new EventEmitter();

  ainfo: AutenticacaoInfo | null = null;
  username: string = '-';

  // Data de início das atualizações (ajustar conforme necessário)
  private dataAtualizacaoAtendimentos = new Date('2026-01-24');
  private dataAtualizacaoConfiguracoes = new Date('2026-01-24');
  
  mostrarTagAtualizacaoAtendimentos = false;
  mostrarTagAtualizacaoConfiguracoes = false;
  mostrarTagNovoModelos = true;

  constructor(private fb: FormBuilder, 
    private router: Router,
    private toast: ToastService,
    private autenticacaoService: AutenticacaoService,
    private usuarioService: UsuarioService,
    private activatedRoute: ActivatedRoute) { 
  }

  ngOnInit() {
    this.autenticacaoService.autenticacaoStatus.subscribe((autenticacao: AutenticacaoDto) => {
      this.ainfo = null;

      if(autenticacao.tipoAutenticacao === TipoAutenticacao.Validado) {
        this.username = this.usuarioService.consultarUsuario().username;
      }
      
    });

    // Verificar se as tags de atualização devem ser exibidas (30 dias)
    this.verificarExibicaoTags();
  }

  private verificarExibicaoTags() {
    const hoje = new Date();
    const diasEmMilissegundos = 30 * 24 * 60 * 60 * 1000;

    // Verificar tag de atualização para Atendimentos
    const diferencaAtendimentos = hoje.getTime() - this.dataAtualizacaoAtendimentos.getTime();
    this.mostrarTagAtualizacaoAtendimentos = diferencaAtendimentos <= diasEmMilissegundos;

    // Verificar tag de atualização para Configurações
    const diferencaConfiguracoes = hoje.getTime() - this.dataAtualizacaoConfiguracoes.getTime();
    this.mostrarTagAtualizacaoConfiguracoes = diferencaConfiguracoes <= diasEmMilissegundos;
  }

  ngAfterViewInit(): void {
    this.onViewInit.emit();

    Sentry.getFeedback()?.attachTo(document.querySelector('#feedback-button')!, {
      isEmailRequired: true,
      isNameRequired: true,
      triggerLabel: "Relatar um Bug",
      formTitle: "Relatar um Bug",
      submitButtonLabel: "Enviar Relatório de Bug",
      cancelButtonLabel: "Cancelar",
      confirmButtonLabel: "Confirmar",
      addScreenshotButtonLabel: "Adicionar uma captura de tela",
      removeScreenshotButtonLabel: "Remover captura de tela",
      nameLabel: "Nome",
      namePlaceholder: "Seu Nome",
      emailLabel: "Email",
      emailPlaceholder: "seu.email@exemplo.org",
      isRequiredLabel: "(obrigatório)",
      messageLabel: "Descrição",
      messagePlaceholder: "Qual é o bug? O que você esperava?",
      successMessageText: "Obrigado pelo seu relatório!"
    })
  }

  abrirPesquisaPaciente() {
    if(this.modelo.controls.nomeCpf.value.length < 3) {
      this.toast.showWarning('Para realizar a pesquisa, informe pelo menos três caractéres do nome ou o CPF do paciente.');
      return;
    }

    this.pacientePesquisaModal.abrir(this.modelo.controls.nomeCpf.value);
  }

  pacienteSelecionado(paciente: PacienteDto) {
    let tipo = this.usuarioService.consultarUsuario().profissionalProfissaoTipo;
    if(tipo === ProfissionalProfissaoTipo.Fonoaudiologo) {
      this.router.navigate(['./exames']);
      return;
    }

    this.router.navigate(['/atendimentos-medicos']);
  }
}
